module.exports = __webpack_public_path__ + "assets/Infinity-loop-icon.4e14edcb.svg";